import React from "react";
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import renderHTML from 'react-render-html';

const GenericList = ({ translate, props }) => {
    return(
      <ul>
        {props.items.map(( item, index ) => 
            <li key={ index } className={ typeof item.class !== 'undefined'? item.class : ''}>{ renderHTML(item.data) }</li>
        )}
      </ul>
    ) 
  };

const mapStateToProps = (state, ownProps) => {
  return {
    translate: getTranslate(state.locale),
    props: ownProps
  };
};

export default connect(mapStateToProps)(GenericList);   


// WEBPACK FOOTER //
// ./src/components/lists/generic-list.jsx